/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalculationParameterEntryStatus } from './CalculationParameterEntryStatus';
import {
    CalculationParameterEntryStatusFromJSON,
    CalculationParameterEntryStatusFromJSONTyped,
    CalculationParameterEntryStatusToJSON,
    CalculationParameterEntryStatusToJSONTyped,
} from './CalculationParameterEntryStatus';

/**
 * 
 * @export
 * @interface CalculationParameterEntryResponse
 */
export interface CalculationParameterEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof CalculationParameterEntryResponse
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof CalculationParameterEntryResponse
     */
    effectiveFrom: Date;
    /**
     * 
     * @type {number}
     * @memberof CalculationParameterEntryResponse
     */
    value: number;
    /**
     * 
     * @type {CalculationParameterEntryStatus}
     * @memberof CalculationParameterEntryResponse
     */
    status: CalculationParameterEntryStatus;
}



/**
 * Check if a given object implements the CalculationParameterEntryResponse interface.
 */
export function instanceOfCalculationParameterEntryResponse(value: object): value is CalculationParameterEntryResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('effectiveFrom' in value) || value['effectiveFrom'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function CalculationParameterEntryResponseFromJSON(json: any): CalculationParameterEntryResponse {
    return CalculationParameterEntryResponseFromJSONTyped(json, false);
}

export function CalculationParameterEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationParameterEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'effectiveFrom': (new Date(json['effectiveFrom'])),
        'value': json['value'],
        'status': CalculationParameterEntryStatusFromJSON(json['status']),
    };
}

export function CalculationParameterEntryResponseToJSON(json: any): CalculationParameterEntryResponse {
    return CalculationParameterEntryResponseToJSONTyped(json, false);
}

export function CalculationParameterEntryResponseToJSONTyped(value?: CalculationParameterEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'effectiveFrom': `${value['effectiveFrom'].getFullYear()}-${String(value['effectiveFrom'].getMonth()+1).padStart(2,'0')}-${String(value['effectiveFrom'].getDate()).padStart(2,'0')}`,
        'value': value['value'],
        'status': CalculationParameterEntryStatusToJSON(value['status']),
    };
}

